import useAdminAccess from "hooks/useAdminAccess";
import { ReactNode } from "react";

/** Do not mount restricted sections: hiding their markup alone still runs queries. */
export default function AdminPermission({
  permission,
  children,
}: {
  permission: string | string[];
  children: ReactNode;
}) {
  const { canAny } = useAdminAccess();
  return canAny(Array.isArray(permission) ? permission : [permission]) ? (
    <>{children}</>
  ) : null;
}
